import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { updateNodeField } from "../reducers/rulesetSlice";

const ListItemWidget = ({ node, field, value, error }) => {
  const dispatch = useDispatch();
  const [newItem, setNewItem] = React.useState("");

  const items = Array.isArray(value)
    ? value
    : value
      ? value.split(",").map((v) => v.trim())
      : [];

  const handleAdd = () => {
    if (!newItem.trim()) return;
    const updatedList = [...items, newItem.trim()];
    dispatch(
      updateNodeField({
        nodeId: node.id,
        field: field.var,
        value: updatedList, // or updatedList.join(", ") if you store as string
      }),
    );
    setNewItem("");
  };

  const handleDelete = (index) => {
    const updatedList = items.filter((_, i) => i !== index);
    dispatch(
      updateNodeField({
        nodeId: node.id,
        field: field.var,
        value: updatedList,
      }),
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          width: field.width ?? 220,
        }}
      >
        <Typography variant="body2" sx={{ fontSize: "0.85rem", mb: 0.5 }}>
          {field.label}
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            size="small"
            value={newItem}
            onChange={(e) => setNewItem(e.target.value)}
            placeholder="Add item..."
            sx={{ flex: 1, "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAdd();
              }
            }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={handleAdd}
            disabled={!newItem.trim()}
            sx={{ minWidth: 50, textTransform: "none" }}
          >
            Add
          </Button>
        </Box>

        {items.length > 0 && (
          <Paper
            variant="outlined"
            sx={{
              mt: 1,
              p: 1,
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              minHeight: 40,
            }}
          >
            {items.map((item, index) => (
              <Box
                key={`${item}-${index}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                  px: 1,
                  py: 0.25,
                }}
              >
                <Typography sx={{ fontSize: "0.8rem", mr: 0.5 }}>
                  {item}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => handleDelete(index)}
                  sx={{ p: 0.2 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Paper>
        )}

        {error && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
            {error}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ListItemWidget;
